import { Button, Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";
import Iconify from "../iconify";

RetryButton.propTypes = {
    message: PropTypes.string,
    onClick: PropTypes.func,
};

export default function RetryButton({ message, onClick }) {
    return (
        <Stack
            spacing={2}
            alignItems="center"
            justifyContent="center"
            sx={{
                minHeight: 400,
                p: 3,
            }}
        >

            <Typography variant="body2" color="text.secondary" textAlign="center">
                {message}
            </Typography>
            <Button
                variant="contained"
                color="primary"
                onClick={onClick}
                startIcon={<Iconify icon="eva:refresh-outline" />}
            >
                Tentar Novamente
            </Button>
        </Stack>
    )
}